import { Box, Modal } from "@mui/material";
import React from "react";
import cssClasses from "./PreviewModal.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useState } from "react";
import { useEffect } from "react";
import PdfIcon from "../../Assets/Images/Common/Pdf.svg";
import ImgIcon from "../../Assets/Images/Common/ImageIcon.svg";

export default function PreviewModal({ open, handleClose, value }) {
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    if (typeof value.value === "object") {
      setDocs([{ uri: window.URL.createObjectURL(value.value), fileName: value.value.name }]);
    } else {
      setDocs([{ uri: value.value }]);
    }
  }, [value]);
  return (
    <Modal
      open={open}
      onClose={() => handleClose({ flag: false })}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper} style={{ width: " min(1000px, 90%)", padding: "30px" }}>
        <div className={cssClasses.mainContainer}>
          <Box className={cssClasses.inputContainer}>
            <div style={{ display: "flex", alignItems: "center", gap: "4rem" }}>
              <ArrowBackIcon sx={{ transform: "scale(2)" }} onClick={() => handleClose()} />
              <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
                <img src={value?.type === "image" ? ImgIcon : PdfIcon} alt="icon" />
                <p style={{ fontSize: "14px", marginBottom: "10px" }}>{value?.name}</p>
              </div>
            </div>
            {/* <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
              <img
                src={downloadIcon}
                alt="download"
                onClick={() => handleDownloadFile()}
                style={{ cursor: "pointer" }}
              />
            </div> */}
          </Box>
          <div>
            <DocViewer documents={docs} pluginRenderers={DocViewerRenderers} style={{ height: "600px" }} />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
